module.exports = __webpack_public_path__ + "img/shilitu.022ae225.png";